import { useOutletContext, Link } from "react-router-dom";
import Container from "@/components/Container";
import { ArrowUpRight } from "lucide-react";

const DEFAULT_STEPS = [
  { title: "Discretion", body: "Properties of consequence rarely advertise themselves. We move through quieter channels — auctions, probate, estates, and private referrals — and take our time before we take our position." },
  { title: "Composition", body: "Before a single trade is booked, an architectural eye redraws the home. Plans first; finishes follow. The numbers must serve the design, not the other way around." },
  { title: "Craft", body: "Trusted trades, considered specification, no surface left unconsidered. The work is patient because the standard does not move." },
  { title: "Presentation", body: "Editorial photography, considered styling, and writing that does justice to the work. A house is sold twice — once in person, once on the page." },
  { title: "Conclusion", body: "Released to a qualified network of buyers, and to the wider market when the moment is right — under the Rubys.Group name, with the standard intact." },
];

export default function Process() {
  const { cms } = useOutletContext() || {};
  const steps = cms?.process?.steps?.length ? cms.process.steps : DEFAULT_STEPS;
  return (
    <div className="pt-36 pb-32">
      <Container>
        <div className="flex items-center gap-4 mb-10">
          <span className="label-mono">No. 03 — Practice</span>
          <span className="h-px w-12 bg-ruby" />
        </div>
        <h1 className="serif-display text-5xl md:text-7xl lg:text-[8rem] text-ink-700 max-w-5xl">
          A practice,<br />
          <span className="serif-italic text-ruby">quietly held.</span>
        </h1>
        <p className="mt-12 text-ink-400 max-w-2xl text-lg lg:text-xl leading-[1.7]">
          There is no formula on display. Each house is brought into the same considered hands — and finished to the same standard, whether it begins as a derelict cottage or a discreet auction lot.
        </p>

        <div className="mt-24">
          {steps.map((s, i) => (
            <div
              key={s.title}
              className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-14 lg:py-20 border-t border-ink-700/12 group"
            >
              <div className="md:col-span-2 editorial-numeral text-5xl lg:text-7xl">{String(i+1).padStart(2,"0")}</div>
              <div className="md:col-span-4">
                <h3 className="serif-display text-5xl lg:text-7xl text-ink-700 group-hover:text-ruby transition-colors duration-500">{s.title}<span className="text-ruby">.</span></h3>
              </div>
              <p className="md:col-span-6 text-ink-400 leading-[1.85] text-base lg:text-lg max-w-xl">{s.body}</p>
            </div>
          ))}
        </div>

        <div className="mt-24 flex items-center gap-4">
          <span className="h-px w-12 bg-ruby" />
          <Link to="/sell" className="btn-link">Bring us a property <ArrowUpRight size={14} /></Link>
        </div>
      </Container>
    </div>
  );
}
